// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ca_a bhu_h bhu_ka bhu_ux bhu_ro bhu_un bhu_rq bhu_rh"};